const Image = ({ path, ...props }) => {
  return <img src={path} {...props} />;
};
export default Image;
